export default {
  smsNotificationsHistory(state) {
    return state.messages
  },
  smsHistoryFilters(state) {
    return state.smsHistoryFilters
  },
  smsStatuses(state) {
    return state.smsStatuses
  },
}
